/*
 *   File : manage-news.js
 *   Author : https://evoqins.com
 *   Description : Manage news page
 *   Integrations : react-toastify
 *   Version : 1.0.0
*/

import { useEffect, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import Cookies from "js-cookie";
import { useLocation, useNavigate } from 'react-router-dom';

//custom component
import { CustomSelectBox } from '../../../Component/FormElements';
import { APIService } from '../../../Service';
import { PrimaryButton, TextButton } from '../../../Component/Buttons';
import { CustomTab, Loader } from '../../../Component/Others';
import { EmptyScreen } from '../../../Component/EmptyComponent';
import { Pagination } from '../../../Component/pagination';
import { ConfirmationModal, ConfirmDeleteModal, ManageNewsModal } from '../../../Component/Modal';
import { Icon } from '../../../Component/Icon';
import { toast } from 'react-toastify';

const ITEMS_PER_PAGE = 12;

const TAB_DATA = [
    {
        id: 1,
        label: "Current news"
    },
    {
        id: 2,
        label: "Archived news"
    },
];


const ManageNews = () => {

    const navigate = useNavigate();
    const { state } = useLocation();

    const newsRef = useRef();
    const is_super_admin = Cookies.get("admin_type") === "1" ? true : false;

    const [toggleMenu, setToggleMenu] = useState(null);
    const [newsData, setNewsData] = useState({});
    const [loading, setLoading] = useState(true);

    const [totalPageCount, setTotalPageCount] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);

    const [deleteId, setDeleteId] = useState(null);
    const [deleteResponse, setDeleteResponse] = useState(false);

    const [countryDataLoading, setCountryDataLoading] = useState(true);

    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState([]);
    const [countrySelect, setCountrySelect] = useState(false);

    const [toggleFilter, setToggleFilter] = useState(false);

    const [tabIndex, setTabIndex] = useState(0);

    const [archiveModal, setArchiveModal] = useState(false);
    const [archiveStatus, setArchiveStatus] = useState(false);
    const [archiveLoader, setArchiveLoader] = useState(false);

    const [archiveData, setArchiveData] = useState({});

    const [manageNewsModal, setManageNewsModal] = useState(false);

    const [editData, setEditData] = useState({});

    useEffect(() => {
        if (state?.tab_index) {
            setTabIndex(state.tab_index);
        } else {
            setTabIndex(1);
        }
    }, [state]);



    useEffect(() => {
        if (archiveModal === true) {
            const modal = new Modal(document.getElementById('confirm-modal'));
            modal.show();
        }
    }, [archiveModal]);


    useEffect(() => {
        if (manageNewsModal === true) {
            const modal = new Modal(document.getElementById('manage-news-modal'));
            modal.show();
        }
    }, [manageNewsModal]);


    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });

        if (is_super_admin === true) {
            _getCountries();
        }
    }, [is_super_admin]);

    // useEffect(() => {
    //     console.log("totalPageCount::", totalPageCount)
    //     if (newsData.total_count === ITEMS_PER_PAGE) {
    //         setCurrentPage(1);
    //     } else if (newsData.total_count > ITEMS_PER_PAGE) {
    //         setCurrentPage(currentPage - 1);
    //     }
    // }, [newsData]);

    useEffect(() => {
        if (tabIndex !== 0) {
            _getNewsList();
        }
    }, [currentPage, selectedCountry, tabIndex]);

    useEffect(() => {
        if (deleteId !== null) {
            const delete_modal = new Modal(document.getElementById('confirm-delete-modal'));
            delete_modal.show();
        }
    }, [deleteId]);

    // useEffect(() => {
    //     if (Object.keys(newsEditData).length !== 0) {
    //         setTitle(newsEditData.data.title);
    //         setImage(newsEditData.data.image_url);
    //         setSelectedTag({ value: newsEditData.data.tag, label: newsEditData.data.tag_name });
    //         setEditorData(newsEditData.data.content);

    //         const html_content = htmlToDraft(newsEditData.data.content); //convert html to draft
    //         const content = ContentState.createFromBlockArray(html_content.contentBlocks);
    //         const updated_content = EditorState.createWithContent(content);

    //         setEditor(updated_content);

    //         if (is_super_admin) {
    //             const updated_selected_countries = newsEditData.data.countries.map(country => {
    //                 return {
    //                     value: country.value,
    //                     label: country.label,
    //                 };
    //             });

    //             setSelectedCountries(updated_selected_countries);
    //         }


    //     }
    // }, [newsEditData]);


    // handle tab change 

    const _handleTabChange = (id) => {
        navigate(window.location.pathname, {
            state: {
                tab_index: id
            }
        });
        setLoading(true);
    };

    // handle toggle menu 
    const _handleToggleMenu = (index) => {
        setToggleMenu(index);
    };

    // handle delete news 
    const _handleDeleteNews = (id) => {
        setDeleteId(id)
        setDeleteResponse(false);
    };


    //handle pagination
    const _handlePagination = (new_start_limit) => {
        const selected_page = Math.floor(new_start_limit / ITEMS_PER_PAGE) + 1;
        setCurrentPage(selected_page);
        if (newsRef.current) {
            newsRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // remove html tags 
    const _removeTags = (content) => {
        if (content === null || content === '') {
            return false;
        } else {
            content = content.replace(/&nbsp;/g, ' ');
            content = content.replace(/(<([^>]+)>)/ig, '');
            return content;
        }
    };

    // handle filter country 
    const _handleSelectCountry = (value) => {
        setSelectedCountry(value);
        setLoading(true);
        setCurrentPage(1);
    };

    // API - Get news list
    const _getNewsList = (page_num = currentPage) => {
        let is_post = true;
        let url = is_super_admin ? 'news/list' : 'CA/news/list';
        let data = {
            "page_num": page_num,
            "limit": ITEMS_PER_PAGE,
            "country_id": selectedCountry?.value || null,
            "archived": tabIndex === 1 ? false : true
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setNewsData(response.data);
                setTotalPageCount(Math.ceil(response.data.total_count / ITEMS_PER_PAGE));
            } else {
                setNewsData({});
            }
            setLoading(false);
        });
    };

    // API - Delete news
    // const _deleteNews = () => {
    //     let is_post = true;
    //     let url = is_super_admin ? 'news/delete' : 'CA/news/delete';
    //     let data = {
    //         "news_id": deleteId
    //     };

    //     APIService(is_post, url, data).then((response) => {
    //         if (response.status_code === 200) {
    //             setDeleteResponse(true);
    //             // setNewsEditData({});
    //             setTitle("");
    //             // setImage(null);
    //             setSelectedTag(null);
    //             setEditorData(null);

    //             setEditor(EditorState.createEmpty());
    //             setSelectedCountries([]);

    //         } else {
    //             setDeleteResponse(false);
    //             toast.dismiss();
    //             toast.error(response.message, {
    //                 type: "error",
    //                 className: "e-toast",
    //             });
    //         }
    //     });
    // };

    // API - Get countries list
    const _getCountries = () => {

        const country_filter_options = [];

        let is_post = false;
        let url = 'general/list-countries';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                // setCountryList(response.data);

                country_filter_options.push({
                    value: null,
                    label: "All"
                });

                response.data.map((country) => (
                    country_filter_options.push({
                        value: country.value,
                        label: country.label
                    })
                ));
                setCountrySelect(true);
                setSelectedCountry(country_filter_options[0]);
                setCountries(country_filter_options);

            } else {
            }
            setCountryDataLoading(false);
        });
    };


    // API - Archive/Unarchive
    const _toggleArchive = () => {
        setArchiveLoader(true);
        let is_post = true;
        let url = is_super_admin ? 'news/archive' : 'CA/news/archive';
        let data = {
            "news_id": archiveData?.news_id || null
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setArchiveStatus(true);

                setTimeout(() => {
                    setArchiveStatus(false);
                }, 200);
                setArchiveData({});

                if (archiveData.archived) {
                    _handleTabChange(1);
                } else {
                    _handleTabChange(2);
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setArchiveLoader(false);
        });
    };

    return (
        <section className='pb-5'>
            <div className={`${is_super_admin ? "e-bg-azureish-white" : "e-bg-lavender-blush-light"} d-flex justify-content-between padding-12px-top padding-52px-lr padding-96px-bottom`}>
                <h1 className='mb-0 e-primary-font-playfair e-font-24 line-height-32px e-text-raisin-black e-font-weight-600'>
                    Manage News
                </h1>
            </div>

            <div className='padding-52px-lr margin-neg-66px-top'>


                <div className='d-flex align-items-center justify-content-between pb-4 '>
                    <div className='d-flex gap-3 overflow-auto e-tab-scroll '>
                        {TAB_DATA.map((tab) => (
                            <CustomTab key={tab.id}
                                data={tab}
                                tabIndex={tabIndex}
                                handleTabChange={_handleTabChange} />
                        ))}
                    </div>

                    <PrimaryButton name="Add new news"
                        className="e-border-radius-16 py-2 px-3"
                        onPress={() => { setManageNewsModal(true); }} />
                </div>

                {/* created history */}
                <div ref={newsRef} className='pt-3'>
                    <div className='d-flex justify-content-end align-items-center'>
                        {/* <h4 className='mb-0 e-text-dark-jungle-green e-primary-font-playfair e-font-18 e-font-weight-500 line-height-28px'>
                            Created news history
                        </h4> */}

                        {/* filter toggle button */}
                        {countrySelect === true &&
                            <img src={toggleFilter ? require("../../../Assets/Image/filter-icon-white.svg").default :
                                require("../../../Assets/Image/filter-icon.svg").default}
                                draggable={false}
                                className={`${toggleFilter ? `e-bg-indigo` : ``} transition e-border-1px-cool-grey e-border-radius-8 p-2 cursor-pointer`}
                                alt='filter'
                                onClick={() => setToggleFilter(!toggleFilter)} />
                        }
                    </div>

                    {/* Filter */}
                    {toggleFilter &&
                        <div className='e-bg-anti-flash-white-dark py-3 px-4 mt-3'>
                            <div className='col-lg-3 col-md-3 col-sm-4 col-8 pe-0'>
                                <CustomSelectBox label="Country"
                                    value={selectedCountry}
                                    options={countries}
                                    type={2}
                                    className="e-bg-white e-border-radius-8 e-table-select "
                                    labelClass="e-font-weight-600"
                                    isSearchable={false}
                                    selectChange={(temp) => _handleSelectCountry(temp)}
                                />
                            </div>
                        </div>
                    }

                    {loading ?
                        <Loader className="min-h-50vh" />  //loader
                        :
                        <>
                            {Object.keys(newsData).length !== 0 && newsData.total_count > 0 ?
                                <>
                                    {newsData.data.map((news, key) => (
                                        <div key={key} className='mt-3 e-bg-white p-3 e-border-radius-16'>
                                            <div className='d-flex align-items-start gap-3'>
                                                <div className='e-bg-black e-border-radius-8' style={{ width: "184px", height: "98px" }}>
                                                    <img src={news.image_url}
                                                        draggable={false}
                                                        className='w- e-border-radius-8 object-fit-contain'
                                                        height={98}
                                                        width={184}
                                                        alt='notification' />
                                                </div>
                                                <div className='w-100'>
                                                    <div className='d-flex align-items-start justify-content-between'>
                                                        <div>
                                                            <span className='e-bg-lust p-1 e-border-radius-40 e-text-white e-alt-font-noto-sans e-font-10 e-font-weight-400 line-height-10px '>
                                                                {news.tag_name}
                                                            </span>
                                                            <span className='e-text-davys-grey e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-16px ps-2'>{news.created_on}</span>
                                                        </div>


                                                        <div className='d-flex align-items-center gap-3 '>
                                                            <p className='mb-0 h-100 text-nowrap e-border-bottom-1px-indig text-decoration-hover-underline d-flex gap-1 align-items-center e-text-indigo e-alt-font-noto-sans e-font-16 e-font-weight-600 line-height-24px cursor-pointer'
                                                                onClick={() => {
                                                                    setArchiveModal(true);
                                                                    setArchiveData(news);
                                                                }}>
                                                                <Icon icon={news.archived ? "show-eye-icon" : "eye-hide-icon"}
                                                                    className='cursor-pointer'
                                                                    size="24px" />
                                                                {news.archived ? "Unarchive" : "Archive"}
                                                            </p>
                                                            <TextButton name="Edit"
                                                                className="e-font-16"
                                                                onPress={() => {
                                                                    setManageNewsModal(true);
                                                                    setEditData(news);
                                                                }} />
                                                        </div>
                                                    </div>
                                                    <h6 className='mb-0 pt-1 e-primary-font-playfair e-font-16 line-height-20px e-text-raisin-black e-font-weight-600'>
                                                        {news.title}
                                                    </h6>
                                                    <p className='mb-0 padding-10px-top e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-22px e-ellipse'>
                                                        {_removeTags(news.content)}
                                                    </p>
                                                </div>

                                                {/* delete and update menu */}
                                                {/* <div className='col-1 text-end'>
                                                    <div className="e-dropdown-more-wrapper position-relative ">
                                                        <img src={require("../../../Assets/Image/Header/menu.svg").default}
                                                            draggable={false}
                                                            className=' e-border-1px-anti-flash-white e-border-radius-50per p-1 cursor-pointer'
                                                            alt='menu'
                                                            onClick={() => _handleToggleMenu(key + 1)} />
                                                        {toggleMenu === key + 1 &&
                                                            <>
                                                                <OverLay isOpen={toggleMenu} onClose={() => setToggleMenu(null)} />
                                                                <div className="e-dropdown-more e-bg-white text-start top-24px right-neg-10px"
                                                                    onClick={() => setToggleMenu(null)}>
                                                                    <p className='mb-3 e-text-rich-black-light e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-16px cursor-pointer text-decoration-hover-underline'
                                                                        onClick={() => _handleDeleteNews(news.news_id)} >
                                                                        Delete
                                                                    </p>

                                                                    <p className='mb-0 e-text-rich-black-light e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-16px cursor-pointer text-decoration-hover-underline'
                                                                        onClick={() => _handleEditNews(news, "edit")} >
                                                                        Edit news
                                                                    </p>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    ))}

                                    {/* pagination */}
                                    {totalPageCount > 1 &&
                                        <div className="d-flex justify-content-center e-gap-0-16 mt-4 pt-3">
                                            <Pagination itemsPerPage={ITEMS_PER_PAGE}
                                                totalPage={totalPageCount}
                                                showFirstLastPages={true}
                                                onChange={_handlePagination} />
                                        </div>
                                    }
                                </>
                                :
                                <div className='min-h-30vh pt-5'>
                                    {/* empty screen */}
                                    <EmptyScreen message="No news found" />
                                </div>
                            }
                        </>
                    }
                </div>
            </div>

            {/*Confirm delete modal */}
            {/* {deleteId !== null &&
                <ConfirmDeleteModal label="news"
                    deleteId={deleteId}
                    response={deleteResponse}
                    delete={() => _deleteNews()}
                    handleClose={() => setDeleteId(null)}
                    success={() => {
                        _getNewsList(1);
                        setLoading(true);
                    }} />
            } */}


            {archiveModal === true &&
                <ConfirmationModal type={2}
                    title={archiveData.archived ? "Unarchive news" : "Archive news"}
                    description={archiveData.archived ? "Do you want to unarchive news?" : "Do you want to archive created news?"}
                    icon={archiveData.archived ? require("../../../Assets/Image/CountryAdmin/ManageBanner/show-banner.svg").default :
                        require("../../../Assets/Image/CountryAdmin/ManageBanner/hide-banner.svg").default
                    }
                    primaryButtonLabel={archiveData.archived ? "Unarchive" : "Archive"}
                    loader={archiveLoader}
                    status={archiveStatus}
                    handleClose={() => {
                        setTimeout(() => {
                            setArchiveModal(false);
                            setArchiveStatus(false);
                            setArchiveData({});
                        }, 200);
                    }}
                    handleSuccess={() => {
                        _toggleArchive();
                    }}
                />
            }

            {manageNewsModal === true &&
                <ManageNewsModal title={editData.news_id ? "Edit news" : "Create news"}
                    primaryButtonLabel={editData.news_id ? "Update news" : "Create news"}
                    editData={editData}
                    handleClose={() => {
                        setTimeout(() => {
                            setManageNewsModal(false);
                            setEditData({});
                        }, 200);
                    }}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setManageNewsModal(false);
                            setLoading(true);
                            
                            if (tabIndex === 2 && editData.news_id) {
                                _getNewsList(currentPage);
                            } else if (tabIndex !== 1) {
                                _handleTabChange(1);
                            } else if (!editData.news_id && currentPage !== 1) {
                                setCurrentPage(1);
                            } else {
                                _getNewsList(currentPage);
                            }
                        }, 200);
                    }} />
            }
        </section>
    )
}

export default ManageNews;
